module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_7042.47bb8d50.png";